/**
 * @fileoverview PUT handler for the "/engagement/campaigns/set_global_frequency_caps" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsSetGlobalFrequencyCapsCacheKeys } from "./constants";
import type {
  PutEngagementCampaignsSetGlobalFrequencyCapsProps,
  EngagementCampaignsSetGlobalFrequencyCapsResult,
} from "./types";

export const putEngagementCampaignsSetGlobalFrequencyCaps = reactQueryMutationAdapter(
  engagementCampaignsSetGlobalFrequencyCapsCacheKeys,
  (
    props: PutEngagementCampaignsSetGlobalFrequencyCapsProps
  ): Promise<EngagementCampaignsSetGlobalFrequencyCapsResult> => {
    return fetch("/engagement/campaigns/set_global_frequency_caps", "PUT", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
